module.exports = __webpack_public_path__ + "files/SPIADI2023 - Rapport National provisoire - juin 2024.b206bf880f691c37daa152c904f7b452.pdf";